export default __webpack_public_path__ + "static/media/filter-tick-icon.73b1e67f.svg";